import { SettingNotifications } from "features/Setting"

export const SettingNotificationsPages = () => {
    return (
        <SettingNotifications />
    )
}